import { SellerRoleEnum } from 'v3/data/store/seller/enum';

const SellerRoleLabelMap: Record<SellerRoleEnum, string> = {
  [SellerRoleEnum.Manager]: 'Gerente',
  [SellerRoleEnum.AssistantManager]: 'Sub-gerente',
  [SellerRoleEnum.Seller]: 'Consultor',
};

export function convertSellerRole(role: SellerRoleEnum): string {
  return SellerRoleLabelMap[role] ?? '-';
}
